<template xmlns="http://www.w3.org/1999/html">
        <b-modal v-model="visible" size="lg" @shown="initLists">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                        <h3> {{ __('settings') }} </h3>
                    </div>
                    <div class="col-md-1">
                        <button type="button" class="close" v-on:click="visible = false">
                            <span aria-hidden="true">&times;</span>
                            <span class="sr-only">{{ __('close') }}</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default="{}">
                <div class="row">
                    <div class="col-md-6 settings-columns not-selected">
                        <h4>{{ __("available_columns") }}</h4>
                        <div class="dd" id="analyze-nestable3" data-output="">
                            <ol class="dd-list" :class="{'dd-empty': columnsNotSelected.length == 0}">
                                <li class="dd-item" v-for="column in columnsNotSelected">
                                    <input type="hidden" :value="column" name="column_not_selected[]" class="item">
                                    <div class="dd-handle">
                                        {{getTrans(column)}}
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="col-md-6 settings-columns selected">
                        <h4>{{ __("selected_columns") }}</h4>
                        <div class="dd" id="analyze-nestable" data-output="">
                            <ol class="dd-list" :class="{'dd-empty': columnsSelected.length == 0}">
                                <li class="dd-item" v-for="column in columnsSelected">
                                    <input type="hidden" :value="column" name="column_selected[]" class="item">
                                    <div class="dd-handle">
                                        {{getTrans(column)}}
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- komunikat pod listami, bezposrednio nad przyciskami stopki -->
                <div v-if="error" class="alert alert-danger m-t m-b-none">{{ error }}</div>
            </template>
            <template v-slot:modal-footer="{}">
                <div class="row m-b">
                    <div class="col-md-12 text-right">
                        <div class="modal-footer">
                            <button type="button" @click="visible = false" class="btn btn-white">{{ __('close') }}</button>
                            <button type="submit"  v-if="!fromPattern" class="btn btn-primary btn-reset-settings" @click="saveColumns('reset')">{{
                                    __('reset_to_default')
                                }}
                            </button>
                            <button type="submit" class="btn btn-primary" @click="saveColumns('save')">{{ __('save') }}</button>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
</template>

<script>
import {Fragment} from "vue-fragment";
import {getTransForAnalyze} from "./mixin";

export default {
    name: "SettingsModal",
    mixins: [getTransForAnalyze],
    components: {Fragment},
    props:{
        columnsSelected:{
            type: Array
        },
        columnsNotSelected:{
            type: Array
        },
        fromPattern:{
            type:Boolean,
            default:false,
        },
        // limit wybranych kolumn (zakladka "Analiza" i zapisany szablon); null = bez limitu
        maxSelected:{
            type:Number,
            default:null,
        }
    },
    data: function () {
        return {
            visible:false,
            error:null,
        }
    },
    watch:{
        visible(value){
            if(value) this.error = null;
        }
    },
    methods:{
        // wlasne id list (nie #nestable/#nestable3) - te na ekranie analizy ma standardowy modal
        // ustawien zakladki 1 (layouts.site.parts.modals), a public/js/table-settings.js wiaze sie po id
        initLists(){
            $('#analyze-nestable, #analyze-nestable3').nestable({
                group: 2,
                maxDepth: 1
            });
        },
        saveColumns(type){
            var selectedColumns= $(".selected .item").map(function() {
                return $(this).val();
            }).get();
            var notSelectedColumns = $(".not-selected .item").map(function() {
                return $(this).val();
            }).get();
            if(type != 'reset' && this.maxSelected !== null && selectedColumns.length > this.maxSelected){
                this.error = this.__('analyze_max_columns_exceeded');
                return;
            }
            this.error = null;
            this.$emit('saveColumns',type, selectedColumns, notSelectedColumns )
        },
        // blad walidacji z serwera (np. limit kolumn) - modal zostaje otwarty
        showError(message){
            this.error = message;
        },
        closeModal(){
            this.visible = false;
        },
        getTrans(column){
          return this.getTransColumn(column)

        }
    },
    mounted() {
    }

}
</script>

<style scoped>

</style>
